<template>
  <div>
    <v-card>
      <div v-if="clamp">
        <div v-for="(element, i) in arrayClamped" :key="i">
          <eternio-search-skeleton :noElevation="true" :page="element"></eternio-search-skeleton>
          <v-divider></v-divider>
        </div>
      </div>
      <div v-else>
        <div v-for="(element, i) in data" :key="i">
          <eternio-search-skeleton :noElevation="true" :page="element"></eternio-search-skeleton>
          <v-divider></v-divider>
        </div>
      </div>
      <div v-for="i in 3" :key="i">
        <v-skeleton-loader
          v-if="loading"
          ref="skeleton"
          type="list-item-avatar-three-line"
          height="136px"
          class="mx-auto"
        ></v-skeleton-loader>
      </div>
      <div class="more-btn title font-weight-regular" v-ripple @click="clicked" v-if="!hideBtn">
        <div style="padding-top: 6px">
          <v-icon class="primary--text" size="50" style="margin-right: 10px">mdi-plus-circle</v-icon>
          Mehr anzeigen
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import SearchSkeleton from '@/components/search/SearchSkeleton.vue'

export default {
  props: ['data', 'clamp', 'to', 'loading', 'hideBtn'],
  computed: {
    arrayClamped () {
      return (this.data.length <= 3) ? this.data : this.data.slice(0, 3)
    }
  },
  components: {
    eternioSearchSkeleton: SearchSkeleton
  },
  methods: {
    clicked () {
      if (this.clamp) {
        this.$router.push({ name: this.to })
      } else {
        this.$emit('loadMore')
      }
    }
  }
}
</script>

<style scoped>
  .more-btn {
    background-color: var(--v-secondary-base);
    width: 100%;
    height: 60px;
    text-align: center;
    color: var(--v-primary-base);
    cursor: pointer
  }
</style>
